/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "../../utils/helpers/pagination";

export default {
  SET_TEACHERS_WITH_PAGINATION(state, data) {
    state.teachers = data.items || [];
    state.pagination = data.pagination || {};
  },
  SET_TEACHERS(state, data) {
    state.teachers = data || [];
  },
  SET_PAGINATION(state, data) {
    state.pagination = { ...state.pagination, ...data };
  },
  SET_TEACHER(state, student) {
    state.teacher = student;
  },
  ADD_TEACHER(state, student) {
    state.teachers.push(student);
  },
  UPDATE_TEACHER(state, student) {
    const userIndex = state.teachers.findIndex((u) => u.id === student.id);
    if (userIndex >= 0) Object.assign(state.teachers[userIndex], student);
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const userIndex = state.teachers.findIndex((u) => u.id === item);
        state.teachers.splice(userIndex, 1);
      });
    } else {
      const userIndex = state.teachers.findIndex((u) => u.id === itemId);
      state.teachers.splice(userIndex, 1);
    }

    state.pagination = setPagination(state.pagination, itemId);
  },
};
